import React, { Fragment } from 'react'
import KinesisPlatformNavLink from './KinesisPlatformNavLink'
import PlatformLink from './PlatformLink'
import RightArrow from 'components/icons/RightArrow'
import MultiServerPlatformNavLink from './MultiServerPlatformNavLink'

const multiServerPlatforms = ['revelation', 'vi']

const Content = ({ platform }) => (
  <Fragment>
    {platform.title}
    <RightArrow stroke="ink" width={21} height={14} />
  </Fragment>
)

const PlatformNavLink = ({ platform }) => {
  if (platform.id === 'kinesis') {
    return (
      <KinesisPlatformNavLink>
        <Content platform={platform} />
      </KinesisPlatformNavLink>
    )
  }
  if (multiServerPlatforms.includes(platform.id)) {
    return (
      <MultiServerPlatformNavLink platform={platform}>
        <Content platform={platform} />
      </MultiServerPlatformNavLink>
    )
  }
  return (
    <PlatformLink href={platform.loginUrl}>
      <Content platform={platform} />
    </PlatformLink>
  )
}

export default PlatformNavLink



// WEBPACK FOOTER //
// ./src/routes/home/components/PlatformNavLink.js